/**
 * Makes the rating stars beside the product title jump to the review widget.
 *
 * The count next to them is already a real anchor rendered by `pta-review-count` — that is what
 * carries the accessible name and the keyboard path, and it works with no JavaScript at all. This
 * only extends the same behaviour to the stars, which are Horizon's stock `review` block and cannot
 * be wrapped in a link without either forking that block or duplicating its hundred lines of SVG.
 *
 * Delegated from `document` rather than bound to the element, deliberately: Horizon re-renders the
 * product details on variant change, which would throw away any listener attached directly to the
 * stars. Delegation has nothing to lose.
 *
 * The stars keep `role="presentation"` and are not focusable, so this adds no keyboard trap and no
 * duplicate tab stop — pointer users get a larger target, everyone else uses the anchor.
 */
const TARGET_ID = 'judgeme_product_reviews';

document.addEventListener('click', (event) => {
  const stars = event.target.closest('.rating-wrapper');
  if (!stars) return;

  /* Never swallow a click that was already on a link — the count anchor sits inside the same
     wrapper and must keep its native behaviour, including modifier-clicks and middle-clicks. */
  if (event.target.closest('a')) return;

  const target = document.getElementById(TARGET_ID);
  if (!target) return;

  event.preventDefault();

  /* Update the address bar so the position is shareable and Back behaves, matching what clicking
     the anchor itself would have done. */
  if (window.history?.replaceState) {
    window.history.replaceState(null, '', `#${TARGET_ID}`);
  }

  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
